import { ERPGIcon } from 'motw_core/UI/Icons/ERPGIcon';
import * as React from 'react';
import RPGIcon from 'source/app/presentation/Shared/RPGIcon/RPGIcon';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';

export function GameIdentityIcon({
	isGameIdentityGoal
}: {
	isGameIdentityGoal: boolean;
}) {
	if (!isGameIdentityGoal) {
		return null;
	}

	return (
		<div
			{...Style(`gameIdentityIconIndicator`, {
				position: 'relative',
				bottom: '114px',
				textShadow: '0px 0px 3px gold',
				fontSize: '12px',
				opacity: 0.8
			})}
		>
			<RPGIcon icon={ERPGIcon.player} />
		</div>
	);
}
